import type { ReactNode } from "react";

/**
 * Un surtitre de section du tableau de bord.
 *
 * ⚠️ **C'est un vrai `h2`**, sous le `h1` de la coque, et pas de la décoration :
 * ce sont ces trois titres qui découpent la page pour qui la parcourt de titre
 * en titre. Ils nomment trois régimes de lecture — ce qui appelle une décision,
 * l'état des lieux, puis les tendances.
 *
 * Remonté ici le jour où `StatsSection` en a eu besoin à son tour : jusque-là
 * une constante de classe suffisait dans `Dashboard`.
 */
export function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <h2 className="text-[11px] font-semibold tracking-[0.14em] text-muted uppercase">
      {children}
    </h2>
  );
}
